import styled from 'styled-components';
import Avatar from '../Avatar';
import { theme } from '../../styles/theme';

export const Container = styled.div`
  display: flex;
  align-items: center;
`;

export const Text = styled(Container)<{ $size: number; $lineHeight: number }>`
  font-size: ${({ $size }) => $size}px;
  line-height: ${({ $lineHeight }) => $lineHeight}px;
  font-weight: 500;
  color: ${theme.colors.secondary600};
`;

export const UserAvatar = styled(Avatar)<{ $gap: number }>`
  margin-right: ${({ $gap }) => $gap}px;
`;

export const Name = styled.div`
  font-weight: 600;
  color: ${theme.colors.secondary900};
`;

export const LabeledDivider = styled.span`
  flex: 0 0 auto;
  width: 3px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  border-radius: 50%;
  background-color: currentColor;
`;
